import { ButtonGroup } from '@components/ButtonGroup';
import { Modal } from '@components/Modal';
import { Typography } from '@mui/material';
import { buildDataTestIdAttribute, buildFullDataTestId, DATA_TEST_ID_SELECTION } from '@src/utils';
import { FC } from 'react';

type ModalDeleteDiagnosesGroupProps = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  deleteDiagnosesGroup: () => void;
};

export const ModalDeleteDiagnosesGroup: FC<ModalDeleteDiagnosesGroupProps> = ({
  open,
  setOpen,
  deleteDiagnosesGroup,
}) => {
  const handleApply = () => {
    setOpen(false);
    deleteDiagnosesGroup();
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const dataTestId = buildFullDataTestId(DATA_TEST_ID_SELECTION, 'modal-delete-giagnoses-group');
  return (
    <Modal
      bodySx={{ padding: '24px' }}
      title="Diagnoses group delete"
      onCancel={handleCancel}
      open={open}
      wrapperProps={{
        PaperProps: {
          sx: {
            maxWidth: '400px',
            width: '100%',
          },
          ...buildDataTestIdAttribute(dataTestId),
        },
      }}
    >
      <Typography variant="label14Regular" color="grey.700">
        Are you sure you want to delete this group?
      </Typography>

      <ButtonGroup
        onApply={handleApply}
        onCancel={handleCancel}
        applyName="Yes"
        cancelName="No"
        color="secondary"
        sx={{ justifyContent: 'space-between', marginTop: '36px' }}
        dataTestId={dataTestId}
      />
    </Modal>
  );
};
